import React from 'react';
import { ArtistSubscriptionFragment, DiscountTypeEnum } from '@minecraft.graphql-operations';
import { gqlSubscription } from '@minecraft.graphql-types';
import { PlanType } from '../../usePlans';
import { useDiscountHook } from './useDiscountHook';
import { PremiumDiscountOffer } from './DiscountModals/PremiumDiscountOffer';
import { CanadianPremiumDiscount } from './DiscountModals/CanadianPremiumDiscount';
import { NeverPaidCohortDiscount } from './DiscountModals/NeverPaidCohortDiscount';
import { TargetAnnualOnDiscountedM2M } from './DiscountModals/TargetAnnualDiscount';

type Props = {
  plans?: PlanType[];
  onCTAClick: () => void;
  subscription?: ArtistSubscriptionFragment | gqlSubscription;
};

export const SpecialDiscountModal = ({ plans, onCTAClick, subscription }: Props) => {
  const { discountType, ...discountFeatues } = useDiscountHook({ plans });

  if (discountType === DiscountTypeEnum.CanadianPremiumDiscount)
    return <CanadianPremiumDiscount {...discountFeatues} onCTAClick={onCTAClick} />;

  if (discountType === DiscountTypeEnum.NeverPaidCohortDiscount)
    return <NeverPaidCohortDiscount {...discountFeatues} onCTAClick={onCTAClick} />;

  if (discountType === DiscountTypeEnum.TargetAnnualOnDiscountedM2M)
    return <TargetAnnualOnDiscountedM2M {...discountFeatues} onCTAClick={onCTAClick} subscription={subscription} />;

  return <PremiumDiscountOffer {...discountFeatues} onCTAClick={onCTAClick} />;
};
